module.exports = __webpack_public_path__ + "static/media/logo_pn_invert_nl.a3f57bb4.svg";